import { createContext, useContext, useState, useCallback } from "react";

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null); // 'quote' | 'booking' | 'callback' | null
  const [prefill, setPrefill] = useState({});

  const open = useCallback((name, data = {}) => { setPrefill(data); setModal(name); }, []);
  const close = useCallback(() => setModal(null), []);

  return (
    <ModalContext.Provider value={{ modal, prefill, open, close }}>
      {children}
    </ModalContext.Provider>
  );
}

export const useModal = () => useContext(ModalContext);
